// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all-network-cases .ui-drawer{bottom:0;height:unset}.all-network-cases__drawer-header{border-bottom:1px solid var(--color-field-border);display:flex;flex-direction:row;padding:16px 16px 10px 16px}.all-network-cases__drawer-header-label{flex:1 1 auto;margin-top:1px}.all-network-cases__drawer-body{padding:16px}.all-network-cases__drawer-body h5{margin-bottom:5px}.all-network-cases__drawer-body .ui-filter{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
